import { useUppy } from '../FileUploaderProvider/react.js'
import useFileUploaderRemoteFilesUploader from './hook.js'

export default function FileUploaderPluginRemoteFilesUploader(props) {
  let uppy = useUppy(props)
  useFileUploaderRemoteFilesUploader({ uppy, prefix: props.prefix })

  return null
}
